import Vue from 'vue'

Vue.filter('strippedSliceContent', (string) => {
  let result = string.replace(/<\/?[^>]+(>|$)/g, '')
  result = result.replace(/&nbsp;/gi, '')
  result = result.replace(/&raquo;/gi, '')
  result = result.replace(/&ndash;/gi, '')
  result = result.slice(0, 300)
  return result
})

export default {}
